<template>
  <div class="contents-container" :class="{ 'contents-container--desktop': !mobile }">
    <!-- Fixed header -->
    <div class="contents-header">
      <div class="contents-header__inner">
        <span class="contents-title">Contenidos</span>
        <span v-if="mobile" class="contents-edit-link" @click="openEditContentMobile()">Editar</span>
      </div>
    </div>
    <!-- Tabs header -->
    <div class="contents-tabs-wrapper">
            <v-tabs
              background-color="#fff"
              class="tabs"
              centered
              grow
              height="60px"
              v-model="activeTab"
            >
              <v-tab key="0"> PANTALLA </v-tab>
              <v-tab key="1"> KIOSKO </v-tab>
            </v-tabs>
    </div>
    <!-- Content -->
    <div class="contents-body">
            <v-tabs-items v-model="activeTab">
              <v-tab-item>
                <v-container class="pa-0">
                  <!-- begin customizable logo  -->
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-card
                        style="border-radius: 0"
                        class="mx-auto"
                        elevation="0"
                      >
                        <v-card
                          elevation="0"
                          style="background-color: #f2f2f2"
                          class="px-12 pb-5 pt-1"
                        >
                          <span id="hour" style="float: right; font-size: 11px"
                            >10:45 AM</span
                          >

                          <v-col
                            cols="12"
                            v-bind:style="{ backgroundColor: color3 }"
                            class="d-flex align-center justify-center"
                          >
                            <v-col
                              style="
                                border: 1px solid white;
                                border-radius: 5px;
                              "
                              v-bind:style="{ backgroundColor: color4 }"
                            >
                              <p v-bind:style="{ color: color5 }">TEXT</p>
                            </v-col>
                          </v-col>
                        </v-card>

                        <v-fade-transition>
                          <v-overlay v-if="hover" absolute color="#036358">
                            <v-btn
                              @click="
                                openPreviewLink(spaceSelected.contentQueue)
                              "
                              style="background-color: white"
                              icon
                            >
                              <v-icon color="#777"> mdi-link </v-icon>
                            </v-btn>
                          </v-overlay>
                        </v-fade-transition>
                      </v-card>
                    </template>
                  </v-hover>
                  <!-- end  customizable logo  -->

                  <!-- start form -->
                  <v-row v-if="!mobile">
                    <v-col class="px-2 pb-0">
                      <v-form ref="formScreen">
                        <v-row class="pt-0">
                          <v-col>
                            <v-text-field
                              :rules="[rules.nameRules]"
                              label="Nombre Contenido*"
                              v-model="objQueueCont.name"
                              dense
                              required
                              maxlength="40"
                              :hint="
                                objQueueCont.name
                                  ? `${objQueueCont.name.length}/40`
                                  : ''
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- color pickers  -->
                        <v-row class="mt-0">
                          <v-col cols="4" class="pa-1">
                            <div style="font-size:10px; line-height:1.2; margin-bottom:4px;">Color<br/>primario</div>
                            <div style="margin-bottom:4px;">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small width="27" height="27" :color="color3" dark v-on="on"></v-btn>
                                </template>
                                <v-color-picker value="#7417BE" v-model="color3" hide-canvas hide-inputs show-swatches class="mx-auto"></v-color-picker>
                              </v-menu>
                            </div>
                            <input v-model="color3" style="width:100%; max-width:70px; padding-left:4px; font-size:10px; background-color:#eee; height:27px; border-radius:5px;" type="text" placeholder="color"/>
                          </v-col>
                          <v-col cols="4" class="pa-1">
                            <div style="font-size:10px; line-height:1.2; margin-bottom:4px;">Color<br/>secundario</div>
                            <div style="margin-bottom:4px;">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small width="27" height="27" :color="color4" dark v-on="on"></v-btn>
                                </template>
                                <v-color-picker value="#7417BE" v-model="color4" hide-canvas hide-inputs show-swatches class="mx-auto"></v-color-picker>
                              </v-menu>
                            </div>
                            <input v-model="color4" style="width:100%; max-width:70px; padding-left:4px; font-size:10px; background-color:#eee; height:27px; border-radius:5px;" type="text" placeholder="color"/>
                          </v-col>
                          <v-col cols="4" class="pa-1">
                            <div style="font-size:10px; line-height:1.2; margin-bottom:4px;">Color<br/>texto</div>
                            <div style="margin-bottom:4px;">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small width="27" height="27" :color="color5" dark v-on="on"></v-btn>
                                </template>
                                <v-color-picker value="#7417BE" v-model="color5" hide-canvas hide-inputs show-swatches class="mx-auto"></v-color-picker>
                              </v-menu>
                            </div>
                            <input v-model="color5" style="width:100%; max-width:70px; padding-left:4px; font-size:10px; background-color:#eee; height:27px; border-radius:5px;" type="text" placeholder="color"/>
                          </v-col>
                        </v-row>
                        <!-- /color pickers  -->

                        <v-row>
                          <!-- <v-col>
                       
                              <ColorPicker :colorSelected="color3"></ColorPicker>
                            </v-col> -->
                        </v-row>

                        <!-- add logo  -->

                        <v-row>
                          <v-col>
                            <v-file-input
                              required
                              dense
                              hide-details
                              v-model="photo"
                              @change="onSelect($event)"
                              chips
                              truncate-length="25"
                              label="Añade tu logo"
                              style="padding-top: 0px"
                            ></v-file-input>
                          </v-col>
                        </v-row>

                        <!-- /add logo  -->

                        <v-row>
                          <v-col class="d-flex align-center pt-0">
                            <v-checkbox
                              hide-details
                              class="pt-0"
                              @click="setClock"
                              v-model="checkbox"
                              :label="`Clock`"
                            ></v-checkbox>
                            <v-checkbox
                              hide-details
                              class="pt-0"
                              @click="setClock"
                              v-model="checkbox2"
                              :label="`Sound`"
                              style="margin-left: 24px;"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>

              <v-tab-item>
                <v-container class="pa-0">
                  <!-- begin customizable logo kiosk -->
                  <!-- begin customizable logo  -->
                  <v-hover>
                    <template v-slot:default="{ hover }">
                      <v-card
                        style="border-radius: 0"
                        class="mx-auto"
                        elevation="0"
                      >
                        <v-card
                          elevation="0"
                          style="background-color: #f2f2f2"
                          class="px-12 pb-5 pt-1"
                        >
                          <span id="hour" style="float: right; font-size: 11px"
                            >10:45 AM</span
                          >

                          <v-col
                            cols="12"
                            v-bind:style="{ backgroundColor: color6 }"
                            class="d-flex align-center justify-center"
                          >
                            <v-col
                              style="
                                border: 1px solid white;
                                border-radius: 5px;
                              "
                              v-bind:style="{ backgroundColor: color7 }"
                            >
                              <p v-bind:style="{ color: color8 }">TEXT</p>
                            </v-col>
                          </v-col>
                        </v-card>

                        <v-fade-transition>
                          <v-overlay v-if="hover" absolute color="#036358">
                            <v-btn
                              @click="
                                openPreviewLink(spaceSelected.contentKiosk)
                              "
                              style="background-color: white"
                              icon
                            >
                              <v-icon color="#777"> mdi-link </v-icon>
                            </v-btn>
                          </v-overlay>
                        </v-fade-transition>
                      </v-card>
                    </template>
                  </v-hover>
                  <!-- end  customizable logo  -->

                  <!-- end  customizable logo  -->

                  <!-- start form -->
                  <v-row v-if="!mobile">
                    <v-col class="px-2 pb-0">
                      <v-form ref="formKiosk">
                        <v-row class="pt-0">
                          <v-col>
                            <v-text-field
                              :rules="[rules.nameRules]"
                              label="Nombre Contenido*"
                              v-model="objQueueContKiosk.name"
                              dense
                              required
                              maxlength="40"
                              :hint="
                                objQueueContKiosk.name
                                  ? `${objQueueContKiosk.name.length}/40`
                                  : ''
                              "
                            ></v-text-field>
                          </v-col>
                        </v-row>

                        <!-- color pickers  -->
                        <v-row class="mt-0">
                          <v-col cols="4" class="pa-1">
                            <div style="font-size:10px; line-height:1.2; margin-bottom:4px;">Color<br/>primario</div>
                            <div style="margin-bottom:4px;">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small width="27" height="27" :color="color6" dark v-on="on"></v-btn>
                                </template>
                                <v-color-picker value="#7417BE" v-model="color6" hide-canvas hide-inputs show-swatches class="mx-auto"></v-color-picker>
                              </v-menu>
                            </div>
                            <input v-model="color6" style="width:100%; max-width:70px; padding-left:4px; font-size:10px; background-color:#eee; height:27px; border-radius:5px;" type="text" placeholder="color"/>
                          </v-col>
                          <v-col cols="4" class="pa-1">
                            <div style="font-size:10px; line-height:1.2; margin-bottom:4px;">Color<br/>secundario</div>
                            <div style="margin-bottom:4px;">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small width="27" height="27" :color="color7" dark v-on="on"></v-btn>
                                </template>
                                <v-color-picker value="#7417BE" v-model="color7" hide-canvas hide-inputs show-swatches class="mx-auto"></v-color-picker>
                              </v-menu>
                            </div>
                            <input v-model="color7" style="width:100%; max-width:70px; padding-left:4px; font-size:10px; background-color:#eee; height:27px; border-radius:5px;" type="text" placeholder="color"/>
                          </v-col>
                          <v-col cols="4" class="pa-1">
                            <div style="font-size:10px; line-height:1.2; margin-bottom:4px;">Color<br/>texto</div>
                            <div style="margin-bottom:4px;">
                              <v-menu offset-y>
                                <template v-slot:activator="{ on }">
                                  <v-btn x-small width="27" height="27" :color="color8" dark v-on="on"></v-btn>
                                </template>
                                <v-color-picker value="#7417BE" v-model="color8" hide-canvas hide-inputs show-swatches class="mx-auto"></v-color-picker>
                              </v-menu>
                            </div>
                            <input v-model="color8" style="width:100%; max-width:70px; padding-left:4px; font-size:10px; background-color:#eee; height:27px; border-radius:5px;" type="text" placeholder="color"/>
                          </v-col>
                        </v-row>
                        <!-- /color pickers  -->

                        <!-- add logo  -->

                        <v-row>
                          <v-col>
                            <v-file-input
                              dense
                              hide-details
                              v-model="photo"
                              @change="onSelect($event)"
                              chips
                              truncate-length="25"
                              label="Añade tu logo"
                              style="padding-top: 0px"
                            ></v-file-input>
                          </v-col>
                        </v-row>

                        <!-- /add logo  -->

                        <v-row>
                          <v-col class="d-flex align-center pt-0">
                            <v-checkbox
                              hide-details
                              class="pt-0"
                              @click="setClock"
                              v-model="checkbox"
                              :label="`Clock`"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
    </div>
    <!-- Fixed footer: Crear button -->
    <div v-if="!mobile" class="contents-footer">
      <v-btn
        v-if="activeTab === 0"
        :loading="isCreatingContent"
        @click="sendHtml(objQueueCont)"
        color="#679940"
        dark
        rounded
        depressed
        small
        min-width="100"
      >Crear</v-btn>
      <v-btn
        v-if="activeTab === 1"
        :loading="isCreatingContent"
        @click="sendHtmlKiosk(objQueueContKiosk)"
        color="#679940"
        dark
        rounded
        depressed
        small
        min-width="100"
      >Crear</v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  name: "CreateContents",
  data: () => ({
    rules: {
      numberRequired: (value) => !!value || "Campo numérico obligatorio.",
      lengthNumber: (v) => (v && v.length <= 5) || "Máximo 5 caracteres.",
      nameRules: (value) => !!value || "Campo obligatorio.",
    },
    mobile: false,
    isCreatingContent: false,
    absolute: true,
    overlay: false,
    file: "",
    photo: null,
    activeTab: "",
    checkbox: true,
    checkbox2: true,
    color3: "#f5b70e",
    color4: "#f6c231",
    color5: "#ffffff",
    color6: "#f5b70e",
    color7: "#f6c231",
    color8: "#ffffff",
  }),
  components: {},
  props: {
    colorSelected: "",
  },
  computed: {
    ...mapState("queues", [
      "spaceSelected",
      "allResouces",
      "objQueueCont",
      "objQueueContKiosk",
      "allQueues",
      "RightMenuAddNewQueue",
      "showRightMenu",
      "allSpaces",
      "RightMenuEditQueue",
    ]),
    ...mapState("app", ["actualProject"]),
  },
  methods: {
    ...mapMutations("queues", [
    ]),
    ...mapActions("queues", ["sendHtmlSpaceStore", "sendHtmlSpaceKioskStore"]),
    openEditContentMobile(){
      this.$router.push({
          name: "EditContentMobile",
      });    
    },
    openPreviewLink(link) {
      window.open(link, "_blank");
    },
    onSelect(event) {
      this.file = event;
    },
    setClock() {
      let element = document.getElementById("hour");

      if (this.checkbox == false) {
        element.style.display = "none";
      } else {
        element.style.display = "";
      }
    },
    async sendHtml(cont) {
      if (this.$refs.formScreen.validate()) {
        this.isCreatingContent = true;
        cont.contentColor = this.color3;
        cont.contentColor2 = this.color4;
        cont.contentColor3 = this.color5;
        cont.miarchivo = this.file;
        if (this.checkbox == true) {
          cont.clock_ = "on";
        } else {
          cont.clock_ = "off";
        }
        if (this.checkbox2 == true) {
          cont.sound_ = "on";
        } else {
          cont.sound_ = "off";
        }
        cont.project = this.actualProject.id;
        let idProject = this.actualProject.id;
        let idSpace = this.spaceSelected.idSpace;

        let dataInfo = [cont, idProject, idSpace];

        await this.sendHtmlSpaceStore(dataInfo);
        this.isCreatingContent = false;
      }
    },
    async sendHtmlKiosk(cont) {
      if (this.$refs.formKiosk.validate()) {
        this.isCreatingContent = true;

        cont.contentColor = this.color6;
        cont.contentColor2 = this.color7;
        cont.contentColor3 = this.color8;
        cont.miarchivo = this.file;
        if (this.checkbox == true) {
          cont.clock_ = "on";
        } else {
          cont.clock_ = "off";
        }
        cont.project = this.actualProject.id;
        let idProject = this.actualProject.id;
        let idSpace = this.spaceSelected.idSpace;
        let dataInfo = [cont, idProject, idSpace];
        await this.sendHtmlSpaceKioskStore(dataInfo);
        this.isCreatingContent = false;
      }
    },
  },
  created() {
    var mobile = {
      Android: function() {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function() {
        return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
      }
    };
        
    if(mobile.any() != null){
      if(this.$route.name == "EditContentMobile"){
        this.mobile = false
      }else{
        this.mobile = true
      }
    }else{
      this.mobile = false
    }
  },
  mounted() {},
  destroyed() {},
};
</script>

<style scoped>
.contents-container {
  display: flex;
  flex-direction: column;
}
.contents-container--desktop {
  min-height: calc(72vh + 16px);
}
.contents-header {
  flex-shrink: 0;
  padding: 0 16px;
}
.contents-header__inner {
  display: flex;
  align-items: center;
  padding: 12px 0;
}
.contents-title {
  color: #777;
  font-size: 18px;
}
.contents-edit-link {
  color: #777;
  font-size: 18px;
  margin-left: auto;
  cursor: pointer;
}
.contents-tabs-wrapper {
  flex-shrink: 0;
  padding: 0 8px;
}
.contents-body {
  flex: 1;
  overflow: auto;
  padding: 0 8px 16px;
}
.contents-footer {
  flex-shrink: 0;
  padding: 12px 0;
  text-align: center;
  border-top: 1px solid #eee;
}
/* hide spinners in input type number:  */
/* Chrome, Safari, Edge, Opera */
>>> input::-webkit-outer-spin-button,
>>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
>>> input[type="number"] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// src/components/CreateContents.vue